import(/* webpackMode: "eager" */ "/app/src/app/(en)/blog/page.jsx");
